import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<div className="flex flex-col items-center justify-center h-screen bg-backgroundColor dark:bg-backgroundDark text-gray-800 dark:text-white">
			<h1 className="text-5xl font-bold text-mainColor dark:text-hoverMainColor mb-4">
				404 - Page Not Found
			</h1>
			<p className="text-lg font-Quicksand mb-6 text-center">
				Sorry, the page you are looking for does not exist.
			</p>
			<Link
				to={"/"}
				className="px-6 py-3 bg-mainColor hover:bg-hoverMainColor text-white font-semibold rounded-lg shadow-md transition-all duration-300"
			>
				Go Back Home
			</Link>
		</div>
	);
};

export default NotFound;
